import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Select,
} from "antd";

import { isValidCPF } from 'cnpj-cpf-validator';
import { apiCand } from "../../../../services/apiCand";
import { maskCpf } from "../../../../utils/maskFunctions";
import { mostrarInfo } from "../../../../utils/messages";
import { obterGrausInstrucao } from "../../../../services/apiAuxiliar";

const { Option } = Select;

const CadInfoPFCPF = (props: any) => {
  //  const [loading, setLoading] = useState(false);
  const nuCpf = props.form.getFieldValue("nuCpf");
  const [erroApi, setErroApi] = useState(false);

  const [grausInstrucao, setGrausInstrucao] = useState<any[]>([]);

  const maskNuCpf = async (isValue: any) => {
    isValue = maskCpf(isValue);
    props.form.setFieldsValue({
      nuCpf: isValue,
    });
  };


  useEffect(() => {
    maskNuCpf(nuCpf);
  }, [nuCpf]);

  useEffect(() => {
    if (erroApi) {
      mostrarInfo("Erro de API", "Não foi possível acessar a API de busca/validação do CPF. Tente novamente mais tarde, por favor. Se o erro persisiter, entre em contato com o suporte.");
      props.form.setFieldsValue({
        nuCpf: "",
      });
      setErroApi(false)
    }
  }, [erroApi])

  useEffect(() => {
    obterGrausInstrucao().then((response) => {
      setGrausInstrucao(response);
    });
  }, []);

  // Retorna CPF se já cadastrado na base
  const getCpfNaBase = async (value: string) => {
    props.setTipLoading("Buscando informações sobre o CPF ...");
    props.setLoading(true);
    await apiCand.get(`/pessoasFisicas/${value}/verifica`).then((response) => {
      props.setLoading(false);
      if (response?.data) { // CPF AINDA NÃO CADASTRADO NA BASE DA PREVIC. LOCALIZADO NA RECEITA
        if (response?.data?.cpf){
          props.setDadosReceitaCpf(response?.data);
          props.form.setFieldsValue({
            nmPessoaFisica: response?.data?.nome,
          });
        } else {
          mostrarInfo("Erro de CPF", "CPF informado já existe na base: " + value);
          props.form.setFieldsValue({
            nuCpf: "",
          });
        }
      } else {
          mostrarInfo("Erro de CPF", response.data);
      }
    })
      .catch(err => {
        props.setLoading(false);
        if (err.response.status !== 404) {
          setErroApi(true);
        }
      });
  };

  // Executado ao sair do campo CPF
  const handleInputBlur = (nuCpf: string) => {
    if (isValidCPF(nuCpf)) {
      nuCpf = nuCpf.replace(/\D/g, ""); //Remove tudo o que não é dígito
      getCpfNaBase(nuCpf);
    }
    //    console.log('Input lost focus:' + nuCpf);
  };

  const handlerGrausInstrucao = async (value: any) => {
    props.form.setFieldsValue({
      grauInstrucao: value.children,
      csGrauInstrucao: value.key,
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} xl={5}>
          <Form.Item
            label='CPF'
            name='nuCpf'
            rules={[
              {
                required: true,
                message: 'O campo CPF é obrigatório.',
              },
              {
                message: 'Insira um CPF válido.',
                validator: (_, value) => {
                  if (value.length === 14) {
                    if (isValidCPF(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject('CPF inválido');
                    }
                  }
                }
              }
            ]}
          >
            <Input autoFocus
              value={props.form.getFieldValue("nuCpf")}
              onChange={(e) => maskNuCpf(e.target.value)}
              maxLength={14}
              onBlur={(e) => handleInputBlur(e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} xl={3}>
          <Form.Item
            label=" "
            labelCol={{ span: 16 }}
          >
            <Button type="primary">Pesquisar</Button>
          </Form.Item>
        </Col>

        <Col xs={24} xl={16}>
          <Form.Item label='Nome' name='nmPessoaFisica'>
            <Input
              onChange={props.atualizarBotoes}
              maxLength={100}
              disabled={true}
              style={{ backgroundColor: props.color.nomeFantasiaColor }} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} xl={10}>
          <Form.Item label="Grau de instrução"
            labelCol={{ span: 80 }}
            name="grauInstrucao"
            colon={false}
            rules={[
              {
                required: true,
                message: "O grau de instrução é obrigatório",
              },
            ]}
          >
            <Select
              disabled={false}
              showSearch
              filterOption
              optionFilterProp='children'
              placeholder='Selecionar...'
              onChange={(_, index) => {
                handlerGrausInstrucao(index);
              }}
            >
              {grausInstrucao?.map((e: any) => (
                <Option key={e.valor} value={e.valor}>
                  {e.descricao}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      {/* </Card> */}
    </>


  );

};

export default CadInfoPFCPF;
